// define properties a user can not change
const PREVENT_OVERRIDE = ['type'];

export default class FormInputConfig {
    constructor(obj) {
        // properties for all inputs
        this.type = null;
        this.name = null;
        this.label = null;
        this.classList = [];
        this.tabIndex = null;
        this.value = '';
        this.id = null;
        this.placeholder = null;
        this.autocomplete = null;

        // TODO: is this necessary
        this.ref = null;

        // TODO: remove
        this.dataRecurly = null;

        this.validation = []; // list of validators and/or validation objects

        // this property used to retain 1 or more properties with a null value
        this.includeNull = [];

        // add custom properties defined by subclass
        // this.extend(obj);
    }

    extend(obj) {
        let self = this;
        if (obj && typeof obj === 'object') {
            for (let key in obj) {
                if (this.hasOwnProperty(key) && obj.hasOwnProperty(key)) {
                    if (PREVENT_OVERRIDE.indexOf(key) !== -1) {
                        console.error('You are not allowed to override:', key);
                    } else {
                        // check includeNull must be an array
                        if (key === 'includeNull' && !Array.isArray(obj[key])) {
                            console.error('FormInputConfig: includeNull must be an array.');
                        }
                        self[key] = obj[key];
                    }
                } else {
                    console.warn("The key '%s'", key, 'is not defined in', this.constructor.name);
                }
            }
        }

        // remove null properties
        if (this instanceof FormInputConfig === false) {
            this._removeNullProperties();
        }
    }

    _removeNullProperties() {
        for (let key in this) {
            if (this.hasOwnProperty(key)) {
                if (this[key] === null && this['includeNull'].indexOf(key) === -1) {
                    console.warn(
                        'removing object key',
                        key,
                        'as the value is null. To keep this property you must include it in includeNull'
                    );
                    delete this[key];
                }
            }
        }
    }

    addClass(className) {
        if (this.classList.indexOf(className) === -1) {
            this.classList.push(className);
        }
    }

    removeClass(className) {
        let idx = this.classList.indexOf(className);
        if (idx >= 0) {
            this.classList.splice(idx, 1);
        }
    }

    renderClassList() {
        return this.classList.join(' ');
    }
}
